import { Box, Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

type BackButtonProps = {
    back: Function;
    classes?: {
        root?: object;
        label?: object;
        icon?: {
            width?: string;
            height?: string;
        };
    };
};

export default function BackButton({ back, classes }: BackButtonProps) {
    return (
        <Box
            display={"inline-flex"}
            sx={{
                alignItems: "center",
                gap: "0.5rem",
                cursor: "pointer",
                ...classes?.root,
            }}
            onClick={() => back()}
        >
            <KeyboardBackspaceIcon {...classes?.icon} />
            <Typography
                sx={{
                    color: "#000",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                    ...classes?.label,
                }}
            >
                Retour
            </Typography>
        </Box>
    );
}
